import { unwrapResult } from "@reduxjs/toolkit"
import { Col, notification, Table, Tabs } from "antd"
import moment from "moment"
import React, { useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../app/store"
import { EditableList } from "../../compnents/list/EditableList"
import { DateTimeFormatSimpleOnlyOne } from "../../models/datetime"
import { ThemeContext } from "../../theme/ThemeContext"
import styles from "./InsuranceSettlementRecord.module.css"
import { RegionColumns } from "./columns"
import { DateRangeType, getDateRange } from "../../compnents/form/DateSelect"
import { RegionQuery } from "./query"
import {
  getInsuranceSettlementRecordExport,
  getInsuranceSettleRegionTotal,
  getInsuranceSettleRegionTotalExport,
} from "./InsuranceSettlementRecordSlice"
import { ISRegionTotalPrintBody } from "../../models/ISRegionTotalPrint"
import { selectTenantName } from "../../app/applicationSlice"

export const InsuranceSettleRegionTotal = () => {
  const dispatch = useDispatch<RootDispatch>()

  const tenantName = useSelector(selectTenantName)

  const theme = useContext(ThemeContext)

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [exportLoading, setExportLoading] = useState(false) //导出 loading

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
    startTime: moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
    endTime: moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
  })

  const [page, setPage] = useState<any>({
    items: [],
    totalAmountData: {},
    total: 0,
  })

  const dataMainList = {
    timeHead: params.startTime,
    timeTail: params.endTime,
    tenantName: tenantName?.split("-")?.[0],
    data: page.items,
  }

  const printDom = () => {
    const content = ISRegionTotalPrintBody(dataMainList)
    const page: any = window.open("", "_blank") // 打开一个新窗口，用于打印
    page.document.write(content) // 写入打印页面的内容
    page.print() // 打印
    page?.close()
  }

  const exportExport = () => {
    setExportLoading(true)
    dispatch(getInsuranceSettleRegionTotalExport({ ...params }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = "医保结算地区汇总.xlsx"
        const selfURL = window[window.webkitURL ? "webkitURL" : "URL"]
        const elink = document.createElement("a")
        if ("download" in elink) {
          elink.download = fileName
          elink.style.display = "none"
          elink.href = selfURL["createObjectURL"](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: "导出成功",
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => setExportLoading(false))
  }
  const getPage = () => {
    setPageLoading(true)
    dispatch(
      getInsuranceSettleRegionTotal({
        ...params,
        current: params.current,
        size: params.size,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records?.filter((v: any) => v?.areaName != "合计"),
          totalAmountData: res.records?.filter(
            (v: any) => v?.areaName == "合计"
          )?.[0],
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    getPage()
  }, [params])

  return (
    <>
      <Col
        style={{
          height: "calc(100% - 10px)",
          padding: "0 15px 10px",
          borderRadius: theme.br,
          backgroundColor: theme.pn,
          marginTop: 10,
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
        }}
      >
        <RegionQuery
          exportLoading={exportLoading}
          loading={pageLoading}
          onValueChange={(v) => {
            if(!v?.timeHead && v?._dateRange == 6){
              return
            }
            setParams({
              ...params,
              ...v,
              current: 1,
              startTime: v?.timeHead
                ? moment(v?.timeHead).format(DateTimeFormatSimpleOnlyOne)
                : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
              endTime: v?.timeTail
                ? moment(v?.timeTail).format(DateTimeFormatSimpleOnlyOne)
                : moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
              timeHead: undefined,
              timeTail: undefined,
            })
          }}
          export={() => {
            exportExport()
          }}
          print={() => {
            printDom()
          }}
        />
        <div
          id="tableHeights"
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <EditableList
            // scroll={{ y: Number(scrollHeight) }}
            style={{
              width: "100%",
              height: "90%",
              overflow: "hidden",
            }}
            page={{
              items: page.items,
              current: params.current,
              size: params.size,
              total: page.total,
            }}
            loading={pageLoading}
            columns={RegionColumns(params.size * (params.current - 1))}
            onChangePage={(current, size) => {
              setParams({ ...params, current, size: size || 10 })
            }}
            summary={() => (
              <Table.Summary fixed>
                <Table.Summary.Row className={styles.total}>
                  <Table.Summary.Cell index={0} align="center">
                    合计
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1}></Table.Summary.Cell>
                  <Table.Summary.Cell index={2} align="center">
                    {page?.totalAmountData?.totalPayAmount
                      ? page?.totalAmountData?.totalPayAmount?.toFixed(2)
                      : "0.00"}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3} align="center">
                    {page?.totalAmountData?.reimbursementAmount
                      ? page?.totalAmountData?.reimbursementAmount?.toFixed(2)
                      : "0.00"}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={4} align="center">
                    {page?.totalAmountData?.jibenylbxtcjjzc
                      ? page?.totalAmountData?.jibenylbxtcjjzc?.toFixed(2)
                      : "0.00"}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5}></Table.Summary.Cell>
                  <Table.Summary.Cell index={6}></Table.Summary.Cell>
                  <Table.Summary.Cell index={7}></Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            )}
          />
        </div>
      </Col>
    </>
  )
}
